<template>
  <div class="pb-section-container margin-top-16">
    <div :class="['pbs-header-container', active ? 'active' : null]">
      <button
        v-if="finishedSection.includes('planPricing') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button
        v-else-if="!active"
        type="button"
        class="pbs-button"
        @click="changeActiveStepIdx(index)"
      >
        Start
      </button>
      <button
        v-else
        type="button"
        class="pbs-close-button"
        @click="changeActiveStepIdx(-1)"
      >
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close" />
      </button>
      <div class="pbs-header">Plan Pricing</div>
      <div
        v-if="finishedSection.includes('planPricing')"
        class="pbs-header-right-container"
      >
        <div class="pbs-check-container">
          <img src="@shared/assets/img/general/check-white.png" alt="Check" />
        </div>
      </div>
    </div>
    <div
      :class="[
        'pbs-body-container pricing-section',
        active ? 'active' : null,
        comfortCreditEnabled ? 'larger' : null,
        anniversaryBonusEnabled ? 'larger' : null,
        comfortCreditCapEnabled ? 'larger' : null,
      ]"
    >
      <div class="pbs-body">
        Set pricing for your
        {{ `${plan.name} Plan` || "Plan Name" }}
        as well as Comfort Credits customers can earn.
      </div>
      <div class="pbs-title-container">
        <div class="pbs-title">Pricing</div>
        <div v-if="plan.planType === 'Hardware'" class="pbs-tooltip-container">
          <button type="button" class="pbs-help-button">i</button>
          <div class="pbs-tooltip">
            *First input will pre-populate second and third field. If priced differently,
            edit.
          </div>
        </div>
      </div>
      <div class="pbs-select-container">
        <div for="charge-frequency" name="charge-frequency" class="sac__font-12 n70">
          This plan will charge customer:
        </div>
        <select
          v-model="chargeFrequency"
          class="pbs-select margin-top-4"
          name="credit-accrualfrequency"
        >
          <option value="Monthly">Monthly</option>
          <option value="Yearly">Yearly</option>
          <option value="2 Years">2 Years</option>
          <option value="3 Years">3 Years</option>
          <option value="5 Years">5 Years</option>
          <option v-if="plan.planType === 'AppOnly'" value="One time">One Time</option>
        </select>
      </div>
      <div class="flex-column align-start">
        <div class="pbs-input-container">
          <label class="pbs-input-label" for="first"> First Unit: </label>
          <div class="flex-row align-end">
            <input
              v-model="priceInitial"
              class="pbs-input"
              placeholder="$0"
              @keypress="isDollar"
            />
            <span class="pbs-input-suffix"> /{{ displayChargeFrequency }} </span>
          </div>
        </div>
        <div class="pbs-input-container">
          <label class="pbs-input-label" for="second"> Second Unit: </label>
          <div class="flex-row align-end">
            <input
              v-model="pricingSecond"
              class="pbs-input"
              placeholder="$0"
              @keypress="isDollar"
            />
            <span class="pbs-input-suffix"> /{{ displayChargeFrequency }} </span>
          </div>
        </div>
        <div class="pbs-input-container">
          <label class="pbs-input-label" for="additional"> Additional Unit(s): </label>
          <div class="flex-row align-end">
            <input
              v-model="pricingAddon"
              class="pbs-input"
              placeholder="$0"
              @keypress="isDollar"
            />
            <span class="pbs-input-suffix"> /{{ displayChargeFrequency }} </span>
          </div>
        </div>
      </div>
      <div class="pbs-title-container margin-top-16">
        <div class="pbs-title">Comfort Credits</div>
        <button
          type="button"
          class="pbs-help-button"
          @click="toggleInfoModal(true, 'comfort-credit')"
        >
          ?
        </button>
      </div>
      <div class="sac__font-12 n70">
        Comfort Credits accumulate in customer accounts and can be applied to an invoice
        at a 1 Comfort Credit : $1 ratio.
      </div>
      <div class="flex-row just-between margin-top-16">
        <div class="pbs-sub-header">Will this plan include Comfort Credits?</div>
        <div class="flex-row">
          <div class="pbs-radio-container">
            <input
              id="comfort-yes"
              type="radio"
              name="comfort-credit"
              :checked="comfortCreditEnabled === true"
              @change="comfortCreditEnabled = true"
            />
            <label for="comfort-yes"> Yes </label>
          </div>
          <div class="pbs-radio-container">
            <input
              id="comfort-no"
              type="radio"
              name="comfort-credit"
              :checked="comfortCreditEnabled === false"
              @change="comfortCreditEnabled = false"
            />
            <label for="comfort-no"> No </label>
          </div>
        </div>
      </div>
      <div :class="['pbs-sub-body-container', comfortCreditEnabled ? 'show' : 'hide']">
        <div class="pbs-sub-title">Comfort Credits will be issued for:</div>
        <div class="pbs-select-container">
          <select
            v-model="creditAccrualMethod"
            aria-label="Type"
            class="pbs-select"
            name="anniv-bonus-type"
          >
            <option value="Member">Member</option>
            <option value="Hub">System</option>
            <option value="Location">Location</option>
          </select>
        </div>
      </div>
      <div :class="['pbs-sub-body-container', comfortCreditEnabled ? 'show' : 'hide']">
        <div class="pbs-sub-title">
          Customers will earn the following Comfort Credits each:
        </div>
        <div class="pbs-select-container">
          <select
            v-model="creditAccrualFrequency"
            aria-label="Frequency"
            class="pbs-select"
            name="charge-frequency"
          >
            <option value="Monthly">Monthly</option>
            <option v-if="!isNonHardwarePlan" value="Yearly">Yearly</option>
          </select>
        </div>
        <div class="flex-column align-start margin-top-16 margin-bottom-16">
          <div class="pbs-input-container">
            <label
              v-if="creditAccrualMethod === 'Hub' || creditAccrualMethod === 'Location'"
              class="pbs-input-label"
              for="first"
            >
              <img alt="cc-icon" src="@shared/assets/img/setting/cc-icon.svg" />
              First Unit:
            </label>
            <div class="flex-row align-end">
              <input
                v-model="comfortCreditInitial"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayCreditAccrualFrequency }} </span>
            </div>
          </div>
          <div
            v-if="creditAccrualMethod === 'Hub' || creditAccrualMethod === 'Location'"
            class="pbs-input-container"
          >
            <label class="pbs-input-label" for="second">
              <img src="@shared/assets/img/setting/cc-icon.svg" alt="cc-icon" />
              Second Unit:
            </label>
            <div class="flex-row align-end">
              <input
                v-model="comfortCreditSecondAmount"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayCreditAccrualFrequency }} </span>
            </div>
          </div>
          <div
            v-if="creditAccrualMethod === 'Hub' || creditAccrualMethod === 'Location'"
            class="pbs-input-container"
          >
            <label class="pbs-input-label" for="additional">
              <img src="@shared/assets/img/setting/cc-icon.svg" alt="cc-icon" />
              Additional Unit(s):
            </label>
            <div class="flex-row align-end">
              <input
                v-model="comfortCreditAddonAmount"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayCreditAccrualFrequency }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row just-between">
        <div class="pbs-sub-header">
          Will there be a Comfort Credits bonus for members on the anniversary?
        </div>
        <div class="flex-row">
          <div class="pbs-radio-container">
            <input
              id="anniv-bonus-yes"
              type="radio"
              name="anniv-bonus"
              :checked="anniversaryBonusEnabled === true"
              @change="anniversaryBonusEnabled = true"
            />
            <label for="comfort-yes"> Yes </label>
          </div>
          <div class="pbs-radio-container">
            <input
              id="anniv-bonus-no"
              type="radio"
              name="anniv-bonus"
              :checked="anniversaryBonusEnabled === false"
              @change="anniversaryBonusEnabled = false"
            />
            <label for="anniv-bonus-no"> No </label>
          </div>
        </div>
      </div>
      <div :class="['pbs-sub-body-container', anniversaryBonusEnabled ? 'show' : 'hide']">
        <div class="pbs-sub-title">Determine the anniversary date from:</div>
        <div class="pbs-select-container">
          <select
            v-model="anniversaryBonusStart"
            aria-label="Basis"
            class="pbs-select"
            name="anniversary-basis"
          >
            <option value="Onboard">Onboard date</option>
            <option value="Membership">Membership Sign-up date</option>
          </select>
        </div>
        <div class="sac__font-10 n60 mt-0 mb-1">
          If the Service Titan Integration is not activated, we will save your preferences
          and update them once you integrate it.
        </div>

        <div class="pbs-sub-title mt-4">Anniversary date bonus:</div>
        <div class="pbs-select-container">
          <select
            v-model="anniversaryBonusFrequency"
            aria-label="Frequency"
            class="pbs-select"
            name="anniversary-frequency"
          >
            <option :value="1">Every 1 year</option>
            <option :value="2">Every 2 years</option>
            <option :value="3">Every 3 years</option>
            <option :value="4">Every 4 years</option>
            <option :value="5">Every 5 years</option>
          </select>
        </div>
        <div
          v-if="creditAccrualMethod === 'Member'"
          class="flex-column align-start margin-top-16 margin-bottom-16"
        >
          <div class="pbs-input-container">
            <div class="flex-row align-end">
              <input
                v-model="anniversaryBonusInitial"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayAnniversaryBonusType }} </span>
            </div>
          </div>
        </div>
        <div
          v-if="creditAccrualMethod === 'Hub' || creditAccrualMethod === 'Location'"
          class="flex-column align-start margin-top-16 margin-bottom-16"
        >
          <div class="pbs-input-container">
            <label class="pbs-input-label" for="first">
              <img alt="cc-icon" src="@shared/assets/img/setting/cc-icon.svg" />
              First Unit:
            </label>
            <div class="flex-row align-end">
              <input
                v-model="anniversaryBonusInitial"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayAnniversaryBonusType }} </span>
            </div>
          </div>
          <div class="pbs-input-container">
            <label class="pbs-input-label" for="second">
              <img src="@shared/assets/img/setting/cc-icon.svg" alt="cc-icon" />
              Second Unit:
            </label>
            <div class="flex-row align-end">
              <input
                v-model="anniversaryBonusSecondAmount"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayAnniversaryBonusType }} </span>
            </div>
          </div>
          <div class="pbs-input-container">
            <label class="pbs-input-label" for="additional">
              <img src="@shared/assets/img/setting/cc-icon.svg" alt="cc-icon" />
              Additional Unit(s):
            </label>
            <div class="flex-row align-end">
              <input
                v-model="anniversaryBonusAddonAmount"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
              <span class="pbs-input-suffix"> /{{ displayAnniversaryBonusType }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row just-between">
        <div class="pbs-sub-header">Will there be a cap limit on Comfort Credits?</div>
        <div class="flex-row">
          <div class="pbs-radio-container">
            <input
              id="limit-yes"
              type="radio"
              name="limit-credit"
              :checked="comfortCreditCapEnabled === true"
              @change="comfortCreditCapEnabled = true"
            />
            <label for="limit-yes"> Yes </label>
          </div>
          <div class="pbs-radio-container">
            <input
              id="limit-no"
              type="radio"
              name="limit-credit"
              :checked="comfortCreditCapEnabled === false"
              @change="comfortCreditCapEnabled = false"
            />
            <label for="limit-no"> No </label>
          </div>
        </div>
      </div>
      <div :class="['pbs-sub-body-container', comfortCreditCapEnabled ? 'show' : 'hide']">
        <div
          v-if="comfortCreditCapEnabled"
          class="flex-column align-start margin-bottom-16"
        >
          <div class="pbs-input-container">
            <div class="flex-row align-end">
              <input
                v-model="comfortCreditCap"
                class="pbs-input"
                placeholder="$0"
                @keypress="isNumber"
              />
            </div>
          </div>
        </div>
      </div>
      <div :class="['pbs-sub-body-container', comfortCreditEnabled ? 'show' : 'hide']">
        <div class="pbs-sub-title">Customers can apply Comfort Credits:</div>
        <div class="flex-column">
          <div class="pbs-radio-container">
            <input
              id="comfort-any"
              v-model="comfortCreditApplication"
              type="radio"
              name="comfort-apply"
              value="Any invoice"
            />
            <label for="comfort-any">
              Any invoice with
              {{ corporation.corporationName }}
            </label>
          </div>
          <div class="pbs-radio-container">
            <input
              id="comfort-hvac"
              v-model="comfortCreditApplication"
              type="radio"
              name="comfort-apply"
              value="HVAC Repair"
            />
            <label for="comfort-hvac"> Only on an HVAC Repair </label>
          </div>
        </div>
        <div class="pbs-input-container margin-top-16">
          <label class="pbs-input-label" for="minimum">
            Minimum invoice required for redemption (optional)
          </label>
          <div class="flex-row align-end">
            <input
              v-model="minRepairCost"
              class="pbs-input width-20"
              placeholder="$0"
              @keypress="isNumber"
            />
          </div>
        </div>
        <div class="pbs-input-container margin-top-16">
          <label class="pbs-input-label med" for="restriction">
            Insert any restrictions (optional)?
          </label>
          <div class="flex-row align-end">
            <input v-model="redemptionRestriction" class="pbs-input" />
          </div>
        </div>
        <div class="pbs-footer">
          *We recommend limiting when customers can cash in Comfort Credits to large
          purchases.
        </div>
      </div>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="buttonDisabled"
          @click="handleContinue"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from "@shared/mixins/formatterMixin";

export default {
  name: "PlanPricing",
  mixins: [formatterMixin],
  props: {
    editing: Boolean,
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    corporation: Object,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    toggleInfoModal: Function,
    markUnfinishedSection: Function,
    markFinishedSection: Function,
  },
  data() {
    return {
      chargeFrequency: "Monthly",
      creditAccrualFrequency: "Monthly",
      priceInitial: null,
      priceSecond: null,
      priceAddon: null,
      comfortCreditEnabled: false,
      comfortCreditInitial: null,
      comfortCreditSecond: null,
      comfortCreditAddon: null,
      comfortCreditApplication: null,
      minRepairCost: null,
      redemptionRestriction: "",
      creditAccrualMethod: "Member",
      anniversaryBonusEnabled: false,
      anniversaryBonusFrequency: 2,
      anniversaryBonusStart: "Onboard",
      anniversaryBonusInitial: null,
      anniversaryBonusSecond: null,
      anniversaryBonusAddon: null,
      comfortCreditCapType: "Member",
      comfortCreditCapEnabled: false,
      comfortCreditCap: null,
    };
  },
  computed: {
    isNonHardwarePlan() {
      return this.plan?.planType !== "Hardware";
    },
    buttonDisabled() {
      const {
        priceInitial,
        pricingSecond,
        pricingAddon,
        comfortCreditEnabled,
        comfortCreditInitial,
        comfortCreditSecondAmount,
        comfortCreditAddonAmount,
        comfortCreditApplication,
      } = this;

      const isValidNumber = (val) =>
        val !== "" && val !== null && Number.isFinite(Number(val));

      // Base price checks
      if (
        !isValidNumber(priceInitial) ||
        !isValidNumber(pricingSecond) ||
        !isValidNumber(pricingAddon)
      ) {
        return true;
      }

      // Comfort credit checks
      if (comfortCreditEnabled === null) return true;

      if (comfortCreditEnabled) {
        if (!comfortCreditApplication) return true;

        if (
          !isValidNumber(comfortCreditInitial) ||
          !isValidNumber(comfortCreditSecondAmount) ||
          !isValidNumber(comfortCreditAddonAmount)
        ) {
          return true;
        }
      }

      return false;
    },
    displayCreditAccrualFrequency() {
      if (this.creditAccrualFrequency === "Yearly") {
        return "year";
      }
      if (this.creditAccrualFrequency === "Monthly") {
        return "month";
      }
      return this.creditAccrualFrequency?.toLowerCase();
    },
    displayChargeFrequency() {
      if (this.chargeFrequency === "Yearly") {
        return "year";
      }
      if (this.chargeFrequency === "Monthly") {
        return "month";
      }
      if (this.chargeFrequency === "One time") {
        return "once";
      }
      return this.chargeFrequency?.toLowerCase();
    },
    displayAnniversaryBonusType() {
      if (this.creditAccrualMethod === "Hub") {
        return "hub";
      }
      if (this.creditAccrualMethod === "Member") {
        return "member";
      }
      if (this.creditAccrualMethod === "Location") {
        return "location";
      }
      return this.creditAccrualMethod?.toLowerCase();
    },
    pricingSecond: {
      get() {
        if (this.priceSecond === null || this.priceSecond === 0) {
          return this.priceInitial;
        }
        return this.priceSecond;
      },
      set(value) {
        this.priceSecond = value;
      },
    },
    pricingAddon: {
      get() {
        if (this.priceAddon === null || this.priceAddon === 0) {
          return this.priceInitial || this.priceSecond;
        }
        return this.priceAddon;
      },
      set(value) {
        this.priceAddon = value;
      },
    },
    comfortCreditSecondAmount: {
      get() {
        if (this.comfortCreditSecond === null) {
          return this.comfortCreditInitial;
        }
        return this.comfortCreditSecond;
      },
      set(value) {
        this.comfortCreditSecond = value;
      },
    },
    comfortCreditAddonAmount: {
      get() {
        if (this.comfortCreditAddon === null) {
          return this.comfortCreditInitial || this.comfortCreditSecond;
        }
        return this.comfortCreditAddon;
      },
      set(value) {
        this.comfortCreditAddon = value;
      },
    },
    anniversaryBonusSecondAmount: {
      get() {
        if (this.anniversaryBonusSecond === null) {
          return this.anniversaryBonusInitial;
        }
        return this.anniversaryBonusSecond;
      },
      set(value) {
        this.anniversaryBonusSecond = value;
      },
    },
    anniversaryBonusAddonAmount: {
      get() {
        if (this.anniversaryBonusAddon === null) {
          return this.anniversaryBonusInitial || this.anniversaryBonusSecond;
        }
        return this.anniversaryBonusAddon;
      },
      set(value) {
        this.anniversaryBonusAddon = value;
      },
    },
  },
  watch: {
    plan(updatedPlan) {
      this.chargeFrequency = updatedPlan.chargeFrequency;
      this.creditAccrualFrequency = updatedPlan?.creditAccrualFrequency || "Monthly";
      this.priceInitial = updatedPlan.priceInitial;
      this.priceSecond = updatedPlan.priceSecond;
      this.priceAddon = updatedPlan.priceAddon;
      this.comfortCreditEnabled = updatedPlan.comfortCreditEnabled ?? false;
      this.comfortCreditInitial = updatedPlan.comfortCreditInitial;
      this.comfortCreditSecond = updatedPlan.comfortCreditSecond;
      this.comfortCreditAddon = updatedPlan.comfortCreditAddon;
      this.comfortCreditApplication = updatedPlan.comfortCreditApplication;
      this.minRepairCost = updatedPlan.minRepairCost;
      this.redemptionRestriction = updatedPlan.redemptionRestriction;
      this.anniversaryBonusEnabled = updatedPlan.anniversaryBonusEnabled ?? false;
      this.creditAccrualMethod =
        updatedPlan.creditAccrualMethod === "Hub"
          ? "Hub"
          : updatedPlan.creditAccrualMethod === "Location"
          ? "Location"
          : "Member";
      this.anniversaryBonusInitial = updatedPlan.anniversaryBonusInitial;
      this.anniversaryBonusSecond = updatedPlan.anniversaryBonusSecond;
      this.anniversaryBonusAddon = updatedPlan.anniversaryBonusAddon;
      this.comfortCreditCapEnabled = !!updatedPlan.comfortCreditCap;
      this.comfortCreditCapType = updatedPlan.comfortCreditCapType;
      this.comfortCreditCap = updatedPlan.comfortCreditCap;
      this.anniversaryBonusFrequency = !updatedPlan.anniversaryBonusFrequency
        ? 2
        : updatedPlan.anniversaryBonusFrequency;
      this.anniversaryBonusStart = updatedPlan.anniversaryBonusStart ?? "Onboard";
    },
    chargeFrequency() {
      this.checkIfIncomplete();
    },
    creditAccrualFrequency() {
      this.checkIfIncomplete();
    },
    priceInitial() {
      this.checkIfIncomplete();
    },
    priceSecond() {
      this.checkIfIncomplete();
    },
    priceAddon() {
      this.checkIfIncomplete();
    },
    comfortCreditEnabled() {
      this.checkIfIncomplete();
    },
    comfortCreditInitial() {
      this.checkIfIncomplete();
    },
    comfortCreditSecond() {
      this.checkIfIncomplete();
    },
    comfortCreditAddon() {
      this.checkIfIncomplete();
    },
    comfortCreditApplication() {
      this.checkIfIncomplete();
    },
    minRepairCost() {
      this.checkIfIncomplete();
    },
    redemptionRestriction() {
      this.checkIfIncomplete();
    },
    anniversaryBonusEnabled() {
      this.checkIfIncomplete();
    },
    creditAccrualMethod() {
      this.checkIfIncomplete();
    },
    anniversaryBonusInitial() {
      this.checkIfIncomplete();
    },
    anniversaryBonusSecond() {
      this.checkIfIncomplete();
    },
    anniversaryBonusAddon() {
      this.checkIfIncomplete();
    },
    comfortCreditCapEnabled() {
      this.checkIfIncomplete();
    },
    comfortCreditCapType() {
      this.checkIfIncomplete();
    },
    comfortCreditCap() {
      this.checkIfIncomplete();
    },
  },
  methods: {
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
        chargeFrequency: this.chargeFrequency,
        creditAccrualFrequency: this.creditAccrualFrequency,
        priceInitial: this.priceInitial,
        priceSecond: this.pricingSecond,
        priceAddon: this.pricingAddon,
        comfortCreditEnabled: this.comfortCreditEnabled,
        comfortCreditInitial: this.comfortCreditInitial,
        comfortCreditSecond: this.comfortCreditSecondAmount,
        comfortCreditAddon: this.comfortCreditAddonAmount,
        comfortCreditApplication: this.comfortCreditApplication,
        minRepairCost: this.minRepairCost,
        redemptionRestriction: this.redemptionRestriction,
        anniversaryBonusEnabled: this.anniversaryBonusEnabled,
        creditAccrualMethod:
          this.creditAccrualMethod === "Member" ? "Subscriber" : this.creditAccrualMethod,
        anniversaryBonusFrequency: this.anniversaryBonusFrequency,
        anniversaryBonusStart: this.anniversaryBonusStart,
        anniversaryBonusInitial: this.anniversaryBonusInitial,
        anniversaryBonusSecond: this.anniversaryBonusSecondAmount,
        anniversaryBonusAddon: this.anniversaryBonusAddonAmount,
        comfortCreditCapEnabled: this.comfortCreditCapEnabled,
        comfortCreditCapType: this.comfortCreditCapType,
        comfortCreditCap: this.comfortCreditCap,
      };
      this.updatePlan(newPlan, "planPricing");
    },
    checkIfIncomplete() {
      if (this.editing || this.finishedSection.includes("planPricing")) {
        let incomplete = false;
        if (this.chargeFrequency !== this.plan.chargeFrequency) {
          incomplete = true;
        }
        if (this.creditAccrualFrequency !== this.plan?.creditAccrualFrequency) {
          incomplete = true;
        }
        if (Number(this.priceInitial) !== Number(this.plan.priceInitial)) {
          incomplete = true;
        }
        if (Number(this.priceSecond) !== Number(this.plan.priceSecond)) {
          incomplete = true;
        }
        if (Number(this.priceAddon) !== Number(this.plan.priceAddon)) {
          incomplete = true;
        }
        if (this.comfortCreditEnabled !== this.plan.comfortCreditEnabled) {
          incomplete = true;
        }
        if (
          Number(this.comfortCreditInitial) !== Number(this.plan.comfortCreditInitial)
        ) {
          incomplete = true;
        }
        if (Number(this.comfortCreditSecond) !== Number(this.plan.comfortCreditSecond)) {
          incomplete = true;
        }
        if (Number(this.comfortCreditAddon) !== Number(this.plan.comfortCreditAddon)) {
          incomplete = true;
        }
        if (this.comfortCreditApplication !== this.plan.comfortCreditApplication) {
          incomplete = true;
        }
        if (this.minRepairCost !== this.plan.minRepairCost) {
          incomplete = true;
        }
        if (this.redemptionRestriction !== this.plan.redemptionRestriction) {
          incomplete = true;
        }
        if (this.anniversaryBonusEnabled !== this.plan.anniversaryBonusEnabled) {
          incomplete = true;
        }
        const converted =
          this.creditAccrualMethod === "Member" ? "Subscriber" : this.creditAccrualMethod;
        if (converted !== this.plan.creditAccrualMethod) {
          incomplete = true;
        }
        if (this.anniversaryBonusEnabled) {
          if (this.anniversaryBonusInitial !== this.plan.anniversaryBonusInitial) {
            incomplete = true;
          }
          if (this.anniversaryBonusStart !== this.plan.anniversaryBonusStart) {
            incomplete = true;
          }
          if (this.anniversaryBonusFrequency !== this.plan.anniversaryBonusFrequency) {
            incomplete = true;
          }
          if (this.anniversaryBonusSecond !== this.plan.anniversaryBonusSecond) {
            incomplete = true;
          }
          if (this.anniversaryBonusAddon !== this.plan.anniversaryBonusAddon) {
            incomplete = true;
          }
        }
        if (
          this.plan.comfortCreditCapEnabled !== undefined &&
          this.comfortCreditCapEnabled !== this.plan.comfortCreditCapEnabled
        ) {
          incomplete = true;
        }
        if (
          this.plan.comfortCreditCapEnabled &&
          this.comfortCreditCap !== this.plan.comfortCreditCap
        ) {
          incomplete = true;
        }
        if (incomplete) {
          this.markUnfinishedSection("planPricing");
        } else {
          this.markFinishedSection("planPricing");
        }
      }
    },
  },
};
</script>
